import { render, staticRenderFns } from "./switchComponent.vue?vue&type=template&id=8b6ba016&scoped=true&"
import script from "./switchComponent.vue?vue&type=script&lang=js&"
export * from "./switchComponent.vue?vue&type=script&lang=js&"
import style0 from "./switchComponent.vue?vue&type=style&index=0&id=8b6ba016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6ba016",
  null
  
)

export default component.exports